<lib-card class="full-width">
    <div class="text-center padding-vertical-small">
        <h2 class="text-paragraph ion-no-margin text-midsmall">{{ title }}</h2>
        <ng-content></ng-content>
    </div>
</lib-card>
